/**
 * Deep snake_case → camelCase key conversion for API payloads.
 *
 * The Eleva backend serializes JSON with SnakeCaseLower; the app's models are
 * camelCase (mirroring the iOS client's convertFromSnakeCase decoding). The
 * caller asserts the result type - the boundary contract is declared by the
 * feature's model interfaces, exactly like the iOS Codable structs.
 */
export function camelize<T>(input: unknown): T {
  return convert(input) as T
}

function convert(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(convert)
  }
  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, entry] of Object.entries(value as Record<string, unknown>)) {
      result[camelKey(key)] = convert(entry)
    }
    return result
  }
  return value
}

function camelKey(key: string): string {
  return key.replace(/_([a-z0-9])/g, (_, char: string) => char.toUpperCase())
}
